import { Auth0Provider } from "@auth0/auth0-react";
import "@configura/web-ui/dist/css/web-ui.css";
import ReactDOM from "react-dom";
import App from "./App";
import { AUTH0_CLIENT_ID, AUTH0_DOMAIN } from "./auth";
import { GlobalErrorContextProvider } from "./GlobalErrorContext";
import "./index.css";
import * as serviceWorker from "./serviceWorker";

ReactDOM.render(
	<GlobalErrorContextProvider>
		<Auth0Provider
			domain={AUTH0_DOMAIN}
			clientId={AUTH0_CLIENT_ID}
			authorizationParams={{
				audience: "catapiadmin",
				redirect_uri: window.location.origin,
			}}
		>
			<App />
		</Auth0Provider>
	</GlobalErrorContextProvider>,
	document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
